"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("@firebase/util");
/**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */
var StatsListener = /** @class */ (function () {
 function StatsListener(collection_) {
 this.collection_ = collection_;
 this.last_ = null;
 }
 StatsListener.prototype.get = function () {
 var newStats = this.collection_.get();
 var delta = util_1.clone(newStats);
 if (this.last_) {
 util_1.forEach(this.last_, function (stat, value) {
 delta[stat] = delta[stat] - value;
 });
 }
 this.last_ = newStats;
 return delta;
 };
 return StatsListener;
}());
exports.StatsListener = StatsListener;

//# sourceMappingURL=StatsListener.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/core/stats/StatsListener.js
// module id = 49
// module chunks = 0